export default __webpack_public_path__ + "static/media/Barlow-SemiBold.03f99d23.otf";